export const pricingStatusPage = {
  id: 'hotel-center-v2-pricing-status',
  name: _TL_('Status'),
  route: 'hotelcenter-v2/pricing-status',
};
